/**
 * Shell's in-place sign-in completion (sc-7039) — a thin binding over the
 * shared @arcraz/arcadia-auth-web establishSession, injecting the shell's
 * app-specific score-claim + device id (sc-7065 dedup). Callers keep the
 * single-arg establishSession(resp) signature.
 */

import type { AuthSessionResponse } from '@arcraz/arcadia-types';
import { establishSession as establishShared } from '@arcraz/arcadia-auth-web';
import { claimAnonymousScores } from '../api/client.js';
import { getOrCreateDeviceId } from '../runtime/identity.js';

export function establishSession(resp: AuthSessionResponse): void {
  establishShared(resp, { claimAnonymousScores, getOrCreateDeviceId });
}
